import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addAgent,
  getAgents,
  getAgent,
  editAgent,
  deleteAgent,
  getAllAgents,
} from "../../store/actions/agent_action";
import { SEARCH_TERMS } from "../enums/agents_enum";
// Get All Data
export const useAllAgents = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.agent);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteAgent(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getAgents({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getAgents({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getAgents({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleAgent = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.agent);
  useEffect(() => {
    dispatch(getAgent(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateAgent = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addAgent(data));
  };
  return [addData];
};
export const useUpdateAgent = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editAgent(id, data));
  };
  return [updateData];
};

export const useSelectAllAgent = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.agent);
    useEffect(() => {
      dispatch(getAllAgents());
    }, []);
    return [data];
  };      